var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75,
    d: "M9 14.6c-.18 0-4.3 0-7.43-3.14C.82 10.71.32 9.82.4 8.73a3.64 3.64 0 0 1 3.32-3.28c.65-.04 1.3.1 1.93.43.18-.65.5-1.2 1.02-1.64A3.52 3.52 0 0 1 9 3.41c.87 0 1.71.29 2.33.83a3 3 0 0 1 1.02 1.64 2.98 2.98 0 0 1 1.93-.43c.84.07 1.64.43 2.26 1.05a3.37 3.37 0 0 1 1.06 2.23c.08 1.1-.42 1.98-1.17 2.73A11.49 11.49 0 0 1 9 14.59Zm-6.92-3.65A10.96 10.96 0 0 0 9 13.86c.04 0 4 0 6.92-2.91.58-.58 1.04-1.3.95-2.15a2.92 2.92 0 0 0-2.62-2.59c-.7-.03-1.35.18-1.9.66-.23.16-.58.07-.58-.26a2.54 2.54 0 0 0-.88-1.75 3.03 3.03 0 0 0-1.85-.65c-.7 0-1.39.22-1.86.65-.51.44-.8 1.02-.88 1.75 0 .33-.35.41-.58.26a2.4 2.4 0 0 0-1.9-.62 2.9 2.9 0 0 0-1.78.84c-.51.47-.8 1.09-.84 1.75-.08.84.32 1.52.88 2.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    d: "m5.16 10.54.05-.15a.8.8 0 0 0 1.56-.32.7.7 0 0 0-.18-.48c.7.03 1.2.45 1.3.92v.02c.04.13.15.3.39.3a.35.35 0 0 0 .35-.34v-.01c-.14-1-1.16-1.6-2.1-1.6-.96 0-1.98.58-2.11 1.6 0 .1.04.18.1.25.07.06.15.1.25.1s.2 0 .27-.07a.3.3 0 0 0 .12-.22Zm6.31-.95c.68.05 1.16.46 1.25.92v.02c.05.13.16.3.4.3a.35.35 0 0 0 .35-.34v-.02c-.13-.92-1.07-1.6-2.1-1.6-1.04 0-1.99.64-2.11 1.6v.02c0 .1.04.18.1.24.06.06.15.1.25.1h.04c.07 0 .15-.03.2-.07.06-.05.1-.13.11-.22a1 1 0 0 1 .07-.22c.12.3.41.52.76.52a.8.8 0 0 0 .81-.81c0-.15-.03-.3-.13-.44Zm-3.35 1.86a.5.5 0 0 1 .2.13.98.98 0 0 0 1.35 0c.05-.05.13-.1.21-.13.09-.02.2-.03.3.04.07.05.13.12.15.2.03.1 0 .2-.05.28-.31.36-.8.58-1.28.58-.49 0-.98-.2-1.28-.58a.32.32 0 0 1-.05-.27.38.38 0 0 1 .16-.21c.1-.07.2-.06.29-.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrb);
export default __webpack_public_path__ + "static/media/orb.0238284655f73df470e2c32d041b64ee.svg";
export { ForwardRef as ReactComponent };